import React from 'react';
import WidgetReference from './WidgetReference';

export default function Membership() {
  return (
    <>
      <WidgetReference guideId="membership" />
    <iframe
      src="https://scribehow.com/o/_ygSvBcHTUyj_X5hGoV2bw/viewer/Setting_up_membership_multipler_for_Sweepstakes__2mWfOUSHS_2eBcCV52k10w"
      height="640"
      title="Membership"
      allowFullScreen
    />
    </>
  );
}
